import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FirmwareMasterComponent } from './firmware-master.component';

const routes: Routes = [
  {
    path: 'firmware-master',
    data: { name: 'firmware master', isTab: false },
    component: FirmwareMasterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FirmwareMasterRoutingModule {}
